<!-->┌──────────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│                                    Common Page                                       │<- ->
<- ->└──────────────────────────────────────────────────────────────────────────────────────┘<--->

<template>
    <loading :is-loading="loading" :wait-times="{ message: 2000 }">
        <inject-html key="header" v-bind="siteHeader"
                     @loading="onLoading('header')" @loaded="onLoaded('header')">
        </inject-html>

        <inject-html key="menu" v-bind="siteMenu" v-if="!noMenu"
                     @loading="onLoading('menu')" @loaded="onLoaded('menu')">
        </inject-html>

        <slot>
            <div class="page-content">
                <div class="container">
                    <slot name="container" />
                </div>
            </div>
        </slot>

        <inject-html key="footer" v-bind="siteFooter"
                     @loading="onLoading('footer')" @loaded="onLoaded('footer')">
        </inject-html>
    </loading>
</template>

<script>
    import InjectHtml from "@/common/inject_html"
    import Loading from "@/common/loading"

    export default {
        name: "Page",
        components: { InjectHtml, Loading },

        props: {
            useCmsFolder: String,   //  if set, access Header, Footer and Menu HTML from the Partials folder here
            userType: String,       //  the type of page to create - [tc] for travel counselor, [ta] for agent, blank for public
            noMenu: Boolean,        //  for sites with menu built into the header, don't try to create the menu
        },

        data() {
            return {
                loading: false,
                sections: {}
            }
        },

        computed: {
            siteHeader() {
                return this.getInjection('Header')
            },
            siteMenu() {
                return this.getInjection('Menu')
            },
            siteFooter() {
                return this.getInjection('Footer')
            },
        },

        methods: {
            getInjection(type) {
                return {
                    key: type,
                    query: 'body',// 'body > div, body > span',
                    clean: 'title, script',
                    class: `site-${type.toLowerCase()}`,
                    url: this.getUrl(type)
                }
            },
            getUrl(type) {
                if (this.useCmsFolder)
                    return `${this.useCmsFolder}/Partial/${type}` + (this.userType ? `?type=${this.userType}` : '')
                else
                    return `${this.userType ? '/agents' : ''}/shell.asp?section=${type.toLowerCase()}&pageIndex=9999`
            },

            onLoading(section) {
                this.sections[section] = 'loading'
                this.loading = true
            },

            onLoaded(section) {
                this.sections[section] = 'loaded'

                if (Object.values(this.sections).filter(value => value != 'loaded').length == 0)
                    this.loading = false
            }
        }
    }
</script>